/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import { View, RView } from 'components/View/'
import style from './styles.js'
import cssStyles from './index.module.css'
import getTextMatchArray from 'utils/getTextMatchArray'
import {
  MailOutlined,
  PhoneOutlined,
  GlobalOutlined,
  HeartOutlined,
  EditFilled,
  HeartFilled,
  DeleteFilled
} from '@ant-design/icons'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { favUsers, isFavUser } from 'stores/FavUsers'
import { IUserItemProps, IFavUsers } from 'types'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const { confirm } = Modal
type nullFunction = () => void

function showDeleteConfirm (onOk: nullFunction, onCancel: nullFunction) {
  confirm({
    title: 'Unfavorite User',
    icon: <ExclamationCircleOutlined />,
    content: 'Are you sure unfavorite this user?',
    okText: 'Yes',
    okType: 'danger',
    cancelText: 'No',
    onOk,
    onCancel
  })
}

const UserDetail = (props: {
  icon: any
  label: string
  filterText: string
}) => {
  const label = getTextMatchArray(props.label, props.filterText)
  return (
    <RView newStyles={style.detailCtn}>
      <props.icon />
      <div css={{ width: 4 }} />
      {label.map((textObject, i) => (
        <span
          key={`${textObject.text}_${i}`}
          style={textObject.match ? style.highlight : { fontSize: 12 }}
        >
          {textObject.text}
        </span>
      ))}
    </RView>
  )
}

const UserItem = (props: IUserItemProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const setFavUser = useSetRecoilState(favUsers)
  const isFavorite = useRecoilValue(isFavUser(props.id))
  const userName = getTextMatchArray(props.name, props.filterText)
  const showModal = () => setIsModalVisible(true)
  const handleOk = () => setIsModalVisible(false)
  const handleCancel = () => setIsModalVisible(false)

  const onToggleFav = () => {
    if (isFavorite) return showDeleteConfirm(confirmToggleFav, () => {})
    confirmToggleFav()
  }

  const confirmToggleFav = () => {
    setFavUser((oldFavUsers: IFavUsers) => ({
      ...oldFavUsers,
      [props.id]: !oldFavUsers[props.id]
    }))
  }

  const { email, phone, website, filterText: text } = props

  return (
    <View newCss={cssStyles.container}>
      <View newStyles={style.imageCtn}>
        <img
          src={`https://avatars.dicebear.com/v2/avataaars/${props.name}.svg?options[mood][]=happy`}
          css={style.image}
        />
      </View>
      <View newStyles={style.detailHolder}>
        <span css={{ marginBottom: 8 }}>
          {userName.map((textObject, i) => (
            <span
              key={`name_${textObject.text}_${i}`}
              style={textObject?.match ? style.nameHighlight : style.name}
            >
              {textObject.text}
            </span>
          ))}
        </span>

        {/* <span style={style.name}>{props.name}</span> */}
        <UserDetail label={email} icon={MailOutlined} filterText={text} />
        <UserDetail label={phone} icon={PhoneOutlined} filterText={text} />
        <UserDetail label={website} icon={GlobalOutlined} filterText={text} />
      </View>
      <RView style={style.actionBar}>
        <View newStyles={style.btnHolder} onClick={onToggleFav}>
          {isFavorite ? (
            <HeartFilled style={{ color: 'red' }} />
          ) : (
            <HeartOutlined />
          )}
        </View>
        <View newStyles={style.btnHolder} onClick={showModal}>
          <EditFilled style={{ color: '#e0e0e0' }} />
        </View>
        <View center flex onClick={showModal}>
          <DeleteFilled style={{ color: '#e0e0e0' }} />
        </View>
      </RView>
      <Modal
        title='Edit/Delete User'
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>You do no have permission to perform this action.</p>
      </Modal>
    </View>
  )
}

export default UserItem
